/* 🤖 this file was generated by svg-to-ts */
export const matIconStorage: {
  name: 'storage';
  data: string;
} = {
  name: 'storage',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"/></svg>`
};
